import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: () => import('../views/Main.vue'),
  children: [{
    path: '/',
    meta: {
      id: 0
    },
    component: () => import('../views/Index.vue'),
  }, {
    path: '/Product',
    meta: {
      id: 1
    },
    component: () => import('../views/Product.vue'),
  }, {
    path: '/Case',
    meta: {
      id: 3
    },
    component: () => import('../views/Case.vue'),
  }, {
    path: '/SolutionMuseum',
    meta: {
      id: 2
    },
    component: () => import('../views/SolutionMuseum.vue'),
  }, {
    path: '/SolutionEducation',
    meta: {
      id: 2
    },
    component: () => import('../views/SolutionEducation.vue'),
  }, {
    path: '/SolutionInstrumentatio',
    meta: {
      id: 2
    },
    component: () => import('../views/SolutionInstrumentatio.vue'),
  }, {
    path: '/News',
    meta: {
      id: 4
    },
    component: () => import('../views/News.vue'),
  }, {
    path: '/About',
    meta: {
      id: 5
    },
    component: () => import('../views/About.vue'),
  },
  {
    path: '/SolutionSecurityAndProtection',
    meta: {
      id: 6
    },
    component: () => import('../views/SolutionSecurityAndProtection.vue'),
  }]
}]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

export default router